import { baseApi } from "../../../shared/api/baseApi"
import { ICreateTimeSlotsArray } from "../model/create/CreateTimeSlots"
import { ISelectedTimeSlot } from "../ui/create/dialogs/model/SelectedTimeSlot"

export const TimeSlotsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getSelectTimeSlots: build.query<any, void>({
      query: () => ({
        url: `getSelectTimeSlots`,
        method: "GET",
      }),
      providesTags: ["TimeSlots", "Interviews"],
    }),
    getTimeSlots: build.query<any, any>({
      query: (params) => ({
        url: `getTimeSlots?${params}`,
        method: "GET",
      }),
      providesTags: ["TimeSlots", "Interviews"],
    }),
    addTimeSlots: build.mutation<any, ICreateTimeSlotsArray>({
      query: (data) => ({
        url: `addTimeSlots`,
        method: "POST",
        body: { ...data },
      }),
      invalidatesTags: ["TimeSlots", "Interviews"],
    }),
    deleteTimeSlots: build.mutation<any, ISelectedTimeSlot>({
      query: (data) => ({
        url: `deleteTimeSlots`,
        method: "DELETE",
        body: { ...data },
      }),
      invalidatesTags: ["TimeSlots", "Interviews"],
    }),
    updateTimeSlots: build.mutation<any, ISelectedTimeSlot>({
      query: (data) => ({
        url: `updateTimeSlots`,
        method: "PATCH",
        body: { ...data },
      }),
      invalidatesTags: ["TimeSlots", "Interviews"],
    }),
  }),
})

export const {
  useGetSelectTimeSlotsQuery,
  useGetTimeSlotsQuery,
  useAddTimeSlotsMutation,
  useDeleteTimeSlotsMutation,
  useUpdateTimeSlotsMutation,
} = TimeSlotsApi
